import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { ViewerContext } from 'common/containers/ViewerContainer';
import isExpectedURLOrigin from 'common/util/isExpectedURLOrigin';
import withContexts from 'common/util/withContexts';

class AdminRedirect extends Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape({
        to: PropTypes.string,
      }),
    }),
    router: PropTypes.object,
    viewer: PropTypes.object,
  };

  componentDidMount() {
    const {
      location: {
        query: { to },
      },
      router,
      viewer,
    } = this.props;
    if (!viewer || !viewer.companies || !viewer.companies.length) {
      router.replace({
        pathname: '/login',
        query: {
          redirect: to,
        },
      });
      return;
    }

    const path = to || '/';
    if (path.startsWith('/api')) {
      router.replace('/');
      return;
    }

    const company =
      viewer.companies.find((c) => !c.integrationAuthRedirectionURL) ?? viewer.companies[0];

    if (company.integrationAuthRedirectionURL) {
      window.location.replace(company.integrationAuthRedirectionURL);
      return;
    }

    const origin = `${window.location.protocol}//${company.subdomain}.${window.location.host}`;
    const adminURL = origin + path;

    if (!isExpectedURLOrigin(adminURL, origin)) {
      router.replace('/');
      return;
    }

    window.location.replace(adminURL);
  }

  render() {
    return <div />;
  }
}

export default compose(withContexts({ viewer: ViewerContext }), hot)(AdminRedirect);
